import axios from 'axios'

const ajax = axios.create({
  //baseURL: 'http://192.168.9.62:8090/',
  baseURL: 'https://apigateway.avajang.com',
  //baseURL: 'https://testapigateway.avajang.com',
  //baseURL: 'http://localhost:51000',
  timeout: 30000
});
export { ajax };
export default {
  install(Vue) {
    Vue.prototype.$ajax = ajax
  }
};
